import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";
import variableEffects from "@/base/global/variables/figma.effects.json";

export const collapseThemeToken: any = {
  //========================== COLORS ==========================//
  contentBg: variableColors["ColorFigmaNeutralWhiteWhite100"],
  headerBg: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorBorder: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextHeading: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextHeadingIcon: variableColors["ColorFigmaProductaccentAccent0150"],

  //=========================== SIZE ===========================//
  contentPadding: "24px",
  paddingSM: 16,
  padding: 24,
  panelGap: 16,
  borderRadiusLG: 12,

  //=========================== EFFECT ===========================//
  boxShadow: variableEffects["BoxShadowElevation1"],

  //=========================== FONT ===========================//
  fontHeight: variableTypography["BodyMediumLineHeight"],
  fontHeightLG: variableTypography["BodyLargeLineHeight"],
  fontSize: variableTypography["BodyMediumFontSize"],
  fontSizeIcon: variableTypography["BodyMediumFontSize"],
  fontSizeLG: variableTypography["BodyLargeFontSize"],
};
